import { useContext } from "react";
import PropTypes from "prop-types";

import { CompanyContext } from "../../../components/CompanyList/CompanyContext";

export const EditableFields = () => {
	const { company } = useContext(CompanyContext);
	const apr = company.fields.apr;
	const payment = company.fields.payment;
	const rate = company.fields.rate;
	if (!apr && !payment && !rate) return null;

	return (
		<div className="tw:mt-4">
			<div className="tw:flex tw:flex-row tw:flex-wrap tw:gap-2">
				{apr ? <EditableField label="APR" value={apr} /> : null}
				{payment ? <EditableField label="Payment" value={payment} /> : null}
				{rate ? <EditableField label="Rate" value={rate} /> : null}
			</div>
		</div>
	);
};

const EditableField = ({ label, value }) => (
	<div className="tw:lg:py-[11px tw:space-y-1 tw:rounded-[12px] tw:bg-white tw:px-3 tw:py-2.5 tw:shadow-[0px_0px_2px_0px_rgba(24,39,75,0.18),0px_6px_12px_-6px_rgba(24,39,75,0.12),0px_8px_24px_-4px_rgba(24,39,75,0.08)] tw:lg:px-[13px]">
		<div className="tw:text-[11px] tw:leading-[100%] tw:font-semibold tw:tracking-[0.22px] tw:text-[#0B6ABE] tw:uppercase tw:lg:text-xs tw:lg:leading-3 tw:lg:tracking-[0.24px]">
			{label}
		</div>
		<div className="tw:text-base tw:leading-[100%] tw:font-semibold tw:text-[#212121] tw:lg:text-2xl tw:lg:leading-6">
			{value}
		</div>
	</div>
);

EditableField.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
};
